<template>
  <Header :style="{background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">
      <div class="top_left_Con">
         <div class="top_left">
             <img  :src="userInfo.imgUrl" alt="" class="logoimg">
        </div>
         <Icon :type="showLeftPx?'md-arrow-round-back':'md-arrow-round-forward'" size="24" style="margin-left:8px;cursor:pointer" @click="chagneLeft" />
         <Icon v-if='roleType==1'   type="md-home" size="24" style="margin-left:8px;cursor:pointer" @click="goback"/>

      </div>
    
    <div class="top_right">
        <div  class="username">
            <img src="../../assets/usrename.png" alt="" class="userimg">
            <span class="spanname">{{userInfo.name}}</span>
        </div>
         <language  @on-lang-change="setLocal1" style="margin-right: 10px;" :lang="local"/>
        <Dropdown trigger="click" class="Tablist" @on-click="changeMenu">
            <div class="oozdiv" >
                <img src="../../assets/setup.png" alt="" class="imgicon">
                <span>{{$t('set')}}</span>
            </div>
            <DropdownMenu slot="list" >
                <DropdownItem name='2' >v-1.1.8</DropdownItem>
                <DropdownItem name='4'  @click.stop="setAdminPwd">{{$t('changepwd')}}</DropdownItem>
                <DropdownItem name='3' @click.stop="exitLogin">{{$t('logout')}}</DropdownItem>
                
            </DropdownMenu>
        </Dropdown>
    </div>
    
     <setAdminModellBox :setAdminModel.sync="adminBox.setAdminModel" :dataRow="adminBox.dataRow" :name="userInfo.name"  :fn="adminBox.callbackAdFn"></setAdminModellBox>

      <!-- 删除弹框组件 -->
      <Logout ref="logoutChild" @ievent = "ievent"  :title='$t("logout")' :cont='$t("topCon.confirmOut")'></Logout>
     
      <TabMenu></TabMenu>
      <div v-show="0">test</div>
  </Header>
</template>
<script>
import common from '@/common/common.js';
import axios from 'axios'
import setAdminModellBox from './setAdminModel';  //修改密码  (管理员身份)
import ImgUpload from "../common/upload";
import TabMenu from "../common/tabMenu.vue";
import language from "../common/language/language.vue";
import { mapMutations, mapActions, mapGetters } from 'vuex'
import Logout from '../common/deleteModel.vue'; // 引入删除弹框组件
    export default {
        name: "Top",
        components: {
            setAdminModellBox,
            ImgUpload,
            TabMenu,
            language,
            Logout
        },
        data(){
            return{
                loading: true,
                disabled:false,
                uInfo:{},
                userInfo:{
                    name:"",
                    imgUrl:""
                },
                formData:{},
                adminBox:{//修改密码框组  （管理员身份）
                    dataRow:{},
                    setAdminModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                }
            }
        },
        computed:{
            local () {
              return this.$store.state.local
            },
            roleType(){
	        	 let res = '3'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
            showLeftPx(){
                return this.$store.state.showLeftPx
            },
            selectId(){
                return this.$store.state.selectId || common.decryptDataUinfo('myselectId','selectId').slice(6,-2)
            }
        },
        watch:{
            selectId(newval){
               this.userInfo.name = newval
            }
        },
        async created(){
            await this.getDataSet()
            // console.log('this.userInfo',this.userInfo)
            // console.log('userInfo',common.decryptData(localStorage.getItem('uInfo')))
            // console.log('this.selectId',this.selectId)

            // common.encryptData(1)
            // console.log('userInfo1111',common.decryptDataUinfo())
            this.userInfo.name =  this.selectId || ''
            if(this.roleType==3){
                this.userInfo.name = this.$store.state?.uInfo?.email
            }
            this.userInfo.imgUrl = (this.$store.state.uInfo && this.$store.state.uInfo.imageFid) ?this.config.sourceUrl+'?fid='+this.$store.state.uInfo.imageFid:require('@/assets/logo.png')
        },
        async mounted(){
            // 设置初始语言
            // console.log('设置初始语言',this.$i18n.locale)
            //  this.setLocal(this.$i18n.locale)
            // let langSet = this.$store.state.langSet?true:false
            //  console.log('this.formData1111',this.formData)
            // if(this.formData.language){
            //     console.log(1111)
            //     this.setLocal({locale:this.formData.language,langSet:langSet})
            // }else{
            //      console.log(2222)
            //     this.setLocal({locale:this.$i18n.locale,langSet:langSet})
            // }
        },
        destroyed(){
            window.clearTimeout(this.timerName);
        },
        methods:{
             ...mapMutations([
              'setLocal',
              'setShowLeft',
              'setShowChildrenSide',
              'setTabMenuList',
              'setTabMenuItem',
              'setSelectId',
              'setDealerToken'
            ]),
            async setLocal1(name){
                await this.subDataSet(name)

            },
            async getDataSet(){
                let langSet = this.$store.state.langSet?true:false
                if(this.roleType==2){
                    let resData = await  this.axios.post(this.config.urlArray.dealerInfo, {id:this.selectId})
                    if(resData){
                        this.formData = resData.data.data
                        this.formData.language = resData.data.data.language?resData.data.data.language.replace(/\_/,'-'):""
                        
                        if(this.formData.language){
                            this.setLocal({locale:this.formData.language,langSet:langSet})
                        }else{
                            this.setLocal({locale:this.$i18n.locale,langSet:langSet})
                        }
                    }
                }else{
                    this.setLocal({locale:this.$i18n.locale,langSet:langSet})
                }
            },
            async subDataSet(name) {//提交表单  
                await this.getDataSet()

                let language = name.replace(/\-/,'_')
                let params = {
                    ...this.formData,
                    id:this.selectId,
                    language:language
                }
                console.log('params',params)
                
                if(this.$store.state.uInfo.roleType==2){
                    if(name==this.formData.language) return
                    this.axios.post(this.config.urlArray.dealerInfoSet, params).then((result) => {

                        if(result.data.code== 11001){
                            common.msg('error',this.$t('topCon.dealerInfoErr'))
                        }

                        if(result.data.code== 1){
                            // this.getDataSet()
                            this.setLocal({locale:name,langSet:true})
                        }
                    })
                }else{
                    this.setLocal({locale:name,langSet:true})
                }
                  
            },
            goback(){//回首页，总后台
                axios.defaults.headers.common['Authorization'] = this.$store.state.uInfo.jwt || common.getToken();
                this.setDealerToken(this.$store.state.uInfo.jwt || common.getToken())
                this.setShowChildrenSide(true)
                let uid = this.$store.state.uInfo.id || sessionStorage.getItem('uInfo').id
                this.setSelectId(uid)
                let tabList = [{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"}]
                let itemD = {activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"}
                this.setTabMenuList(tabList);
                this.setTabMenuItem(itemD);
                this.$router.push({ name: 'home'})
            },
            chagneLeft(){
                let val = !this.showLeftPx
                this.setShowLeft(val)
            },
            exitLogin(){  // 退出登录
                this.$refs.logoutChild.showit();
            },
            ievent() {// 删除
                  // 清除数据-----只清空当前会话存储的数据
                  common.removeStorage(this.$store,this.$router)
            },
            
            changeMenu(name){
                if(name == 3){
                    this.exitLogin() //退出登录
                }else if(name == 4){
                    this.setAdminPwd() //管理员修改密码
                }
            },
            setAdminPwd(params){ //管理员修改密码
                this.adminBox.setAdminModel = true
                this.adminBox.dataRow = this.uInfo
                this.adminBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.adminBox.setAdminModel = false;
                }
            },

        }
    }
</script>
<style>
   
    .ivu-layout-header{
        padding: 0 50px 0 0px;
        height: 64px;
        position: fixed;
        line-height: 64px;
        /* z-index:1016; */
        /* z-index:1013; */
        z-index:1012;
        border-top: 1px #c5c8ce solid;
        top: 0;
        right: 0;
        width: 100%;
        box-sizing: border-box;
    }
  
    .h2s{
        float: left;
    }
    .top_left_Con{
        float: left;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .top_left{
        width: 260px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .top_left .logoimg{
        width: auto;
        height: 90%;
    }
    .top_right{
        float: right;
        display: flex;
        height: 100%;
        align-items: center;
        text-align: center;
    }
    .imgicon{
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
    .ivu-dropdown-rel{
        display: flex !important;
    }
    .username{
        margin: 0px 15px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .ivu-dropdown-item:hover{
        background: #1c9add !important;
        color: #fff;
    }
    .userimg{
        width: 25px;
        height: 25px;
    }
    .spanname{
        font-weight: bold;
        margin: 0px 10px;
    }

    .ivu-form .ivu-form-item-label{
        width:120px !important;
        text-align: center !important;
        text-indent: 1px;
      }
      .ivu-form-item-content{
        margin-left: 120px !important;
        flex-grow: 1;
      }
    .oozdiv{
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .oozdiv span{
        margin-left:10px;
        font-weight: bold;
    }
    .endtime{
        color: #ff0000
    }
    .feedbackIcon{
        margin-top: 7px;
    }
    .feedback{
        z-index:999;
        text-align:center;
        border-radius:100%;
        color: #ffffff;
        line-height:10px;
        width: 50px;
        height: 50px;
        position: fixed;
        right: 15px;
        bottom: 20px;
        background: #0e6ae7;
        cursor: pointer;
        opacity: 0.7;
    }
    .feedback:hover{
        opacity: 1;
    }
    .feedbackText{
        font-size: 10px;
    }
</style>
